import Vue from 'vue'

// API resources
import apiModelPortfolio from '@/api/modules/model-portfolio'

// Mutations
import { RESET_MODULE, ADD_MODEL_PORTFOLIO_LIST, ADD_MODEL_PORTFOLIO_META, ADD_MODEL_PORTFOLIO_IN_LIST } from '@/store/mutation-types'


// Default state
const getDefaultState = () => {
  return {
    list: [],
    meta: {},
    filters: {}
  }
}
const state = getDefaultState()

// ----------------------------------------------------------------------

const actions = {
  fetchModelPortfolios ({ commit }, filters = {}) {
    return apiModelPortfolio.fetchModelPortfolios({ status: 'visible', ...filters })
      .then(data => {
        commit(ADD_MODEL_PORTFOLIO_LIST, data.portfolioTemplates)
        commit(ADD_MODEL_PORTFOLIO_META, data.meta)
        return data
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  fetchModelPortfolioById ({ commit }, modelPortfolioId) {
    return apiModelPortfolio.fetchModelPortfolioById(modelPortfolioId)
      .then(data => {
        commit(ADD_MODEL_PORTFOLIO_IN_LIST, data)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  resetState (context) {
    context.commit(RESET_MODULE)
  }
}

const mutations = {
  [ADD_MODEL_PORTFOLIO_LIST] (state, data) {
    state.list = data
  },

  [ADD_MODEL_PORTFOLIO_META] (state, meta) {
    state.meta = meta
  },

  [ADD_MODEL_PORTFOLIO_IN_LIST] (state, data) {
    const index = state.list.findIndex(line => {
      return parseInt(line.id) === parseInt(data.id)
    })

    let list = state.list
    list.splice(index, 1, data)
    
    Vue.set(state, 'list', list)
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  getById: ({ list }) => (id) => {
    return list.find(contract => parseInt(contract.id) === parseInt(id)) || {}
  },
}

export default () => ({
  namespaced: true,
  state,
  actions,
  getters,
  mutations
})
